export const MISSING_DIR = '0'
export const EXISTING_CONFIG = '2'
export const EMPTY_PROJECT = '3'
export const NON_NEXT_PROJECT = '4'
export const TAILWIND_CONFIG_MISSING = '5'
